module.exports = __webpack_public_path__ + "img/6ef69e7.svg";